const invertedMessages = {
  Close: 'CloseLabel',
  Menu: 'Header.tooltip.Menu',
  'Open Discovery Center': 'certs.open.discovery.center',
};

export default invertedMessages;
